/*
 * The view for the description on the topic page
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicDetails/template/topicDetailsTemplate.html",
], function (Marionette, TopicDetailsTemplate) {
  var TopicDetailsView = {};

  TopicDetailsView.topicDetailsView = Marionette.ItemView.extend({
    template: TopicDetailsTemplate,
    modelEvents: {
      change: "render",
    },
    textboxes: {
      "#descriptionTextField": {
        enableSelector: ["#descriptionTextField", ".item-label"],
        modelAttribute: "intentDescription",
        placeholder: "topic.description",
        textArea: true,
      },
    },
  });

  return TopicDetailsView;
});
